module.exports = __webpack_public_path__ + "static/img/11.1225d35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/sanxing/11.png
// module id = fdWz
// module chunks = 0